export const availabilityInjectors = {
  dateProvider: Symbol('dateProvider'),
  probes: Symbol('probes'),
  monthsToDisplay: Symbol('monthsToDisplay'),
  dayWidth: Symbol('dayWidth'),
};
